module.exports = __webpack_public_path__ + "img/logo-bottom.c27a0c44.png";